export {
  LIGHTREACH_APPLICATION_EXISTS_REASON,
  LIGHTREACH_RESERVE_NOW_REASON_FALLBACK,
} from "../../../ProposalSetup/financing/lightreach/lightreach-application-copy"

export const LIGHTREACH_EYEBROW = `LightReach (Battery Only)`
